const adminAppSubmissionStatus = {
    inDevelopment: 'InDevelopment',
    submitted: 'Submitted',
    approved: 'Approved',
};

export default adminAppSubmissionStatus;
